import { render, staticRenderFns } from "./RadarEChart.vue?vue&type=template&id=640f1278"
import script from "./RadarEChart.vue?vue&type=script&lang=js"
export * from "./RadarEChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports